import { Subject } from 'rxjs'
import { Observable } from 'rxjs/internal/Observable'
import { tap } from 'rxjs/operators'
import { ObservableCacheMethod } from './common'

export interface IObservableCacheDestroyerConfig {
  forceRefresh: Subject<void>
}

export function ObservableCacheDestroyer(
  destructoConfig: IObservableCacheDestroyerConfig
) {
  return function (
    _target: Object,
    _propertyKey: string,
    propertyDescriptor: TypedPropertyDescriptor<
      ObservableCacheMethod<Observable<any>>
    >
  ) {
    const oldMethod = propertyDescriptor.value
    if (propertyDescriptor && propertyDescriptor.value) {
      ;(propertyDescriptor.value as any) = function (...args: Array<any>) {
        // pipe onto the old method so that if we are forcing a refresh, we call this force refresh value
        return (oldMethod.call(this, ...args) as Observable<any>).pipe(
          tap(() => {
            if (destructoConfig.forceRefresh) {
              destructoConfig.forceRefresh.next()
            }
          })
        )
      }
    }
    return propertyDescriptor
  }
}
